import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyJoinDimensions } from './shared-dimensions.js';
import { seatTermStatusValueLabels, seatTypeValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'board_health.active_applications': {
        aggregations: ['sum'],
        label: 'Applications In Progress',
        type: 'number',
    },
    'board_health.days_until_expiration': {
        aggregations: ['avg'],
        label: 'Days Until Expiration',
        type: 'number',
    },
};
/**
 * Combination data source: Meeting Bodies x Seats x Seat Terms x Members x Positions x Applicants.
 * Full governance picture: body composition with positions, vacancies, term status, and active
 * pipeline to fill open seats.
 */
export const boardHealthCube = {
    category: 'Governance',
    description: 'Full governance picture: body composition, positions, vacancies, term status, and active pipeline.',
    label: 'Board Health & Governance',
    requiredModule: 'hasTenure',
    measures: {
        'board_health.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'board_health.sum_total_applications': {
            label: 'Total Applications Received',
            type: 'number',
        },
        'board_health.vacant_count': { label: 'Vacant Seats', type: 'number' },
    },
    dimensions: {
        ...meetingBodyJoinDimensions,
        ...aggregatableDimensions,
        // Seat
        'board_health.allow_applications': { label: 'Allow Applications', type: 'boolean' },
        'board_health.appointed_by': { label: 'Appointed By', type: 'string' },
        'board_health.days_vacant': { label: 'Days Vacant', type: 'number' },
        'board_health.has_term_limit': { label: 'Has Term Limit', type: 'boolean' },
        'board_health.is_vacant': { label: 'Is Vacant', type: 'boolean' },
        'board_health.number': { label: 'Seat Number', type: 'number' },
        'board_health.requirements': { label: 'Seat Requirements', narrative: true, type: 'string' },
        'board_health.term_length': { label: 'Seat Term Length', type: 'number' },
        'board_health.term_limit': { label: 'Seat Term Limit', type: 'number' },
        'board_health.title': { label: 'Seat Title', type: 'string' },
        'board_health.type': { label: 'Seat Type', type: 'string', valueLabels: seatTypeValueLabels },
        // Current Term (computed)
        'board_health.current_term_status': {
            label: 'Current Term Status',
            type: 'string',
            valueLabels: seatTermStatusValueLabels,
        },
        // Current Member (computed)
        'board_health.current_member_email': { label: 'Current Member Email', type: 'string' },
        'board_health.current_member_first_name': {
            label: 'Current Member First Name',
            type: 'string',
        },
        'board_health.current_member_last_name': {
            label: 'Current Member Last Name',
            type: 'string',
        },
        // Current Position (computed)
        'board_health.current_position': { label: 'Current Position', type: 'string' },
        // Applicant Pipeline (computed)
        'board_health.total_applications': { label: 'Applications Received', type: 'number' },
    },
    timeDimensions: {
        'board_health.current_term_end_date': { label: 'Current Term End Date', type: 'date' },
        'board_health.created_at': { label: 'Created At', type: 'date' },
        'board_health.updated_at': { label: 'Updated At', type: 'date' },
        'board_health.vacant_since': { label: 'Vacant Since', type: 'date' },
    },
};
